import { action, observable, makeObservable } from 'mobx';

export default class FieldState<T> {
  constructor(public value: T) {
    // This uses `makeObservable` instead of `makeAutoObservable` because it is
    // extended in other child classes.
    makeObservable(this, {
      onChange: action,
      value: observable,
    });
  }

  public onChange = (value: T): void => {
    this.value = value;
  };
}
